"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionTypes = require("../actionTypes");

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setOfferPasswordAction = function setOfferPasswordAction(status) {
  return {
    status: status,
    type: _actionTypes2.default.SET_OFFER_PASSWORD
  };
};

exports.default = setOfferPasswordAction;